export default "__VITE_ASSET__BKEF$aaM__"